// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2S_G2","inputWrap":"CustomTip_inputWrap__2VLwa"};